import "./index.css";
import "./i18nextConf";
import "./sentry";

import { ApolloClient, ApolloLink, ApolloProvider, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const password = localStorage.getItem("password-hash");
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: password ?? "",
        },
    };
});

const link = ApolloLink.from([
    authLink,
    createUploadLink({
        uri: `${process.env.REACT_APP_BASE_URL}/api/graphql`,
    }),
    createHttpLink({
        uri: `${process.env.REACT_APP_BASE_URL}/api/graphql`,
    }),
]);

const client = new ApolloClient({
    cache: new InMemoryCache(),
    link,
});

const basePath = (process.env.REACT_APP_BASE_URL ?? "").replace(/https?:\/\/[^/]+/, "");

console.log("basePath", basePath);

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={basePath}>
            <ApolloProvider client={client}>
                <App />
            </ApolloProvider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root"),
);

serviceWorkerRegistration.register();
